import { OwnProps } from '~/types/ownProps';

const step = {
  route: '/homeowners-insurance/quotes/auto-claims',
  breadcrumbStep: 'property',
  isAccessible: ({ application: { isAutoOnly } }: OwnProps): boolean => isAutoOnly,
};

export default step;
